module.exports = "<router-outlet>\n\n</router-outlet>"